import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  handleDetailResponse,
  handleListResponse,
  isEmpty,
  seo,
  ValidateExtensionImge,
} from "utils/utils";
import { getMasterList } from "reduxStore/action/masterActions";
import {
  addRaiseTicket,
  getRaiseTicketDetail,
  updateRaiseTicket,
} from "reduxStore/action/raiseTicket(Support)Actions";
import ImageRender from "component/common/ImageRender";
import { MasterTypeHelper } from "utils/constants";

const AddEditRaiseTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [ticketIssue, setTicketIssue] = useState([]);
  const ticketId = new URLSearchParams(window.location.search).get("ticket_id");
  const [form, setForm] = useState(null);

  const searchIssueSelector = useSelector((state) => state?.masterData);
  const raiseTicketDetailSelector = useSelector((state) => state.raiseTicket);

  useEffect(() => {
    const { response } = searchIssueSelector;
    if (response) {
      if (response?.status === 200) {
        setTicketIssue(handleListResponse(response.data));
      } else {
        setTicketIssue([]);
      }
    }
  }, [searchIssueSelector]);
  useEffect(() => {
    dispatch(getMasterList({ type: MasterTypeHelper.support }));
    if (!isEmpty(ticketId)) {
      dispatch(getRaiseTicketDetail({ ticket_id: ticketId }));
    }
  }, [dispatch, ticketId]);
  useEffect(() => {
    const { response, detail, create } = raiseTicketDetailSelector;
    if (response && detail) {
      if (response?.status === 200) {
        setForm(handleDetailResponse(response?.data));
      } else {
        setForm(null);
      }
    }
    if (response && create) {
      navigate("/raise_ticket");
    }
  }, [raiseTicketDetailSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleValid = () => {
    let err = {};
    let formError = false;

    if (!form?.title) {
      formError = true;
      err["title"] = strings.titleErr;
    }
    if (!form?.reason) {
      formError = true;
      err["reason"] = strings.issueErr;
    }
    if (!isEmpty(err)) {
      formError = true;
    }

    setFormVaild(err);
    return formError;
  };

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      if (form.raw) {
        formData.append("image", form.raw);
      }
      formData.append("title", form.title);
      formData.append("reason", form.reason);
      form.remark && formData.append("remark", form.remark);
      if (isEmpty(ticketId)) {
        dispatch(addRaiseTicket(formData));
      } else {
        formData.append("ticket_id", ticketId);
        dispatch(updateRaiseTicket(formData));
      }
    }
  };

  useEffect(() => {
    seo({
      title: "Raise Ticket Form",
      metaDescription: "Raice ticket form",
      canonicalLink: window.location.href,
    });
  }, []);
  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target.files[0]);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        ...form,
        preview: preview,
        raw: image,
      };
      setForm(nextFormState);
    }
  };


  return (
    <div className="page-body">
      <Breadcrumb
        title={ticketId ? strings.editRaiseTicket : strings.addRaiseTicket}
        url={"/raise_ticket"}
        isBackBtn={true}
        parentListing={strings.raiseTicketList}
        titleactive={
          ticketId ? strings.editRaiseTicket : strings.addRaiseTicket
        }
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>
                  {ticketId ? strings.editRaiseTicket : strings.addRaiseTicket}
                </h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.title}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="title"
                          value={form?.title}
                          placeholder={strings.title}
                          onChange={handleInputField}
                        />
                        {formVaild.title && (
                          <span style={{ color: "red" }}>
                            {formVaild.title}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <label htmlFor="example">
                        {strings.issue}
                        <span className="required-field"></span>
                      </label>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="reason"
                        value={form?.reason}
                        onChange={handleInputField}
                      >
                        <option value="">
                          {strings.selectIssue}
                        </option>
                        {ticketIssue?.length ? (
                          ticketIssue.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.title}
                            </option>
                          ))
                        ) : (
                          <option>{strings.Loading}</option>
                        )}
                      </select>
                      {formVaild.reason && (
                        <span style={{ color: "red" }}>{formVaild.reason}</span>
                      )}
                    </div>
                  </div>
                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.image}
                        </label>
                        {(!isEmpty(form?.preview) ||
                          (form?.image && form?.image !== "undefined")) && (
                            <ImageRender
                              baseUrl={form?.preview ? "" : form?.base_url}
                              imageUrl={form?.preview || form?.image}
                              thumbnailUrl={form?.preview || form?.image}
                            />
                          )}
                        <input
                          className="form-control"
                          type="file"
                          name="file"
                          onChange={handleChange}
                        />
                        {formVaild.image && (
                          <span style={{ color: "red" }}>
                            {formVaild.image}
                          </span>
                        )}
                        {formVaild.validMedia && (
                          <span style={{ color: "red" }}>
                            {formVaild.validMedia}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form?.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          onClick={() => handleSubmit()}
                          className="btn btn-color"
                          type="button"
                        >
                          {ticketId ? strings.update : strings.submit}
                        </button>
                      </div>
                    </div>
                    {!isEmpty(formVaild) && (
                      <div className="col-md-12 float-right">
                        <span
                          style={{
                            color: "red",
                            float: "right",
                            // padding: "5px 15px 25px 5px",
                          }}
                        >
                          {strings.fieldRequired}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddEditRaiseTicket;
